<template>
  <div
    class="home-products"
    :class="isFullWidth ? '' : 'mx-auto pt-4 px-5 lg:px-20'"
  >
    <ProductSliderContainer
      v-if="transformedProducts.length"
      :products="transformedProducts"
      :loading="loading"
      :title="homeProductsTitle"
      :description="homeProductsDescription"
      :see-all-link-text="seeAllLinkText"
      :see-all-link-slug="seeAllLinkSlug"
      :has-banner="hasBanner"
      :banner="banner"
      :has-controls-outside-container="hasControlsOutsideContainer"
      :is-full-width="isFullWidth"
    />
  </div>
</template>

<script lang="ts">
import ProductSliderContainer from '~/components/organisms/Product/ProductSlider/ProductSliderContainer.vue';

import { limitByKeysCustomerFilter } from '~~/helpers/commercetools/graphql/limitByKeysCustomerFilter';
import extractBestsellerValidSKUs from '~~/helpers/cms/extractBestsellerValidSKUs';
import type { ProductSliderBanner as ProductSliderBannerType } from '~~/types/components/ProductSliderBanner/ProductSliderBanner';
import { transformProductsForNativeRouting } from '~~/helpers/routes/nativeRouting/transformProductsForNativeRouting';

export default defineComponent({
  name: 'HomeProducts',
  components: {
    ProductSliderContainer,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    commaSeparatedSkus: {
      type: String,
      default: '',
    },
    seeAllLinkText: {
      type: String,
      default: null,
    },
    seeAllLinkSlug: {
      type: String,
      default: null,
    },
    hasBanner: {
      type: Boolean,
      default: false,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
    banner: {
      type: Object as PropType<ProductSliderBannerType>,
      default: () => {

        return {};
      
      },
    },
    hasControlsOutsideContainer: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const skuListCacheId = 'bestsellerProducts' + props.commaSeparatedSkus
      .replace(/,/g, '')
      .replace(/ /g, '');
    const {
      productsInStock: bestsellerProductsBasedOnSkuList,
      search: searchProductsBasedOnSkus,
      loading,
    } = useProductRelated(skuListCacheId);
    const { countryCode } = useLocalization();

    const homeProductsTitle = computed(() => {

      return props.title || props.banner.header;
    
    });
    const homeProductsDescription = computed(() => {

      return props.banner.description;
    
    });

    onBeforeMount(async () => {

      const extractionResult = extractBestsellerValidSKUs(props.commaSeparatedSkus);

      if (extractionResult.skus.length > 0) {

        const searchParams = {
          customFilters: limitByKeysCustomerFilter(extractionResult.skus),
        };
        await searchProductsBasedOnSkus(searchParams);
      
      }
      extractionResult.warnings.forEach(warning => {

        console.warn(warning);
      
      });
    
    });

    const transformedProducts = computed(() =>
      transformProductsForNativeRouting(bestsellerProductsBasedOnSkuList.value, countryCode.value),
    );

    return {
      transformedProducts,
      loading,
      homeProductsTitle,
      homeProductsDescription,
    };
  
  },
});

</script>
